import { formatSelectionsArray, truncateSelectedValues } from './utils'
import { doorsData } from '@cinch-nx/data-search'

export const getFormattedDoors = (doorSelections: string[] = []) =>
  truncateSelectedValues(formatSelectionsArray(doorSelections, doorsData))
